<template>
  <div class="tab-bar" :class="{ 'dark-theme': isDark }">
    <div class="tab-list" ref="tabList">
      <div
        v-for="tab in tabs"
        :key="tab.key"
        class="tab-item"
        :class="{ 'tab-active': activeTabKey === tab.key }"
        @click="switchTab(tab)"
        @contextmenu.prevent="showContextMenu($event, tab)"
      >
        <span class="tab-title">{{ tab.title }}</span>
        <i
          v-if="tab.key !== '/home/dashboard'"
          class="el-icon-close tab-close"
          @click.stop="handleCloseTab(tab)"
        ></i>
      </div>
    </div>

    <!-- 右键菜单 -->
    <div
      v-if="contextMenu.visible"
      class="tab-context-menu"
      :style="{ left: contextMenu.x + 'px', top: contextMenu.y + 'px' }"
    >
      <div class="context-menu-item" @click="closeThisTab">
        <i class="el-icon-close"></i>
        <span>关闭</span>
      </div>
      <div class="context-menu-item" @click="closeOtherTabs">
        <i class="el-icon-document-delete"></i>
        <span>关闭其他</span>
      </div>
      <div class="context-menu-item" @click="closeAllTabs">
        <i class="el-icon-delete"></i>
        <span>关闭全部</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'TabBar',
  data() {
    return {
      isDark: false,
      contextMenu: {
        visible: false,
        x: 0,
        y: 0,
        tab: null
      }
    }
  },
  computed: {
    ...mapState('tabs', ['tabs', 'activeTabKey'])
  },
  mounted() {
    this.isDark = localStorage.getItem('theme') === 'dark'
    this.$root.$on('theme-change', (dark) => {
      this.isDark = dark
    })
    document.addEventListener('click', this.hideContextMenu)
  },
  beforeDestroy() {
    this.$root.$off('theme-change')
    document.removeEventListener('click', this.hideContextMenu)
  },
  methods: {
    switchTab(tab) {
      this.$router.push({ path: tab.path, query: tab.query })
    },
    handleCloseTab(tab) {
      this.$store.dispatch('tabs/closeTab', {
        key: tab.key,
        $router: this.$router
      })
    },
    showContextMenu(event, tab) {
      this.contextMenu = {
        visible: true,
        x: event.clientX,
        y: event.clientY,
        tab
      }
    },
    hideContextMenu() {
      this.contextMenu.visible = false
    },
    closeThisTab() {
      if (this.contextMenu.tab) {
        this.handleCloseTab(this.contextMenu.tab)
      }
      this.hideContextMenu()
    },
    closeOtherTabs() {
      if (this.contextMenu.tab) {
        this.$store.dispatch('tabs/closeOtherTabs', {
          key: this.contextMenu.tab.key,
          $router: this.$router
        })
      }
      this.hideContextMenu()
    },
    closeAllTabs() {
      this.$store.dispatch('tabs/closeAllTabs')
      this.$router.push('/home/dashboard')
      this.hideContextMenu()
    }
  }
}
</script>

<style scoped>
.tab-bar {
  display: flex;
  align-items: center;
  background: var(--bg-color);
  border-bottom: 1px solid var(--border-color);
  padding: 0 8px;
  min-height: 36px;
  transition: all 0.3s ease;
  position: relative;
  z-index: 10;
}

.tab-list {
  display: flex;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  flex: 1;
  gap: 2px;
  scrollbar-width: none;
}

.tab-list::-webkit-scrollbar {
  display: none;
}

.tab-item {
  display: flex;
  align-items: center;
  padding: 4px 12px;
  font-size: 12px;
  color: var(--text-color-secondary);
  cursor: pointer;
  border: 1px solid transparent;
  border-bottom: none;
  border-radius: 4px 4px 0 0;
  white-space: nowrap;
  user-select: none;
  transition: all 0.2s ease;
  position: relative;
  margin-top: 4px;
  gap: 6px;
}

.tab-item:hover {
  color: var(--text-color);
  background: var(--bg-color-light);
}

.tab-item.tab-active {
  color: var(--primary-color);
  background: var(--bg-color-light);
  border-color: var(--border-color);
  font-weight: 500;
}

.tab-item.tab-active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 1px;
  background: var(--bg-color-light);
}

.tab-title {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tab-close {
  font-size: 12px;
  padding: 2px;
  border-radius: 50%;
  transition: all 0.2s ease;
  opacity: 0.6;
  flex-shrink: 0;
}

.tab-close:hover {
  background: rgba(0, 0, 0, 0.1);
  opacity: 1;
}

.dark-theme .tab-close:hover {
  background: rgba(255, 255, 255, 0.15);
}

/* 右键菜单 */
.tab-context-menu {
  position: fixed;
  background: var(--bg-color);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  z-index: 9999;
  min-width: 130px;
  padding: 4px 0;
}

.context-menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  font-size: 13px;
  color: var(--text-color);
  cursor: pointer;
  transition: background 0.15s;
}

.context-menu-item:hover {
  background: var(--bg-color-light);
  color: var(--primary-color);
}

.context-menu-item i {
  font-size: 14px;
  color: var(--text-color-secondary);
}

.context-menu-item:hover i {
  color: var(--primary-color);
}
</style>
